import { styled } from 'styled-components';
import { mediaQuery, sizes } from '../styles/styles.js';

export const FuuzeContainer = styled.div`
  margin: 0px auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 1rem;
  flex: 1;

  @media ${mediaQuery.tablet} {
    padding: 2rem;
    gap: 32px;
    max-width: ${sizes.desktop};
  }

  @media ${mediaQuery.desktop} {
    max-width: ${sizes.xl};
  }
`;

export const RawContainer = styled.div`
  width: 100%;

  @media ${mediaQuery.tablet} {
    margin: 0 auto;
    max-width: ${sizes.desktop};
  }

  @media ${mediaQuery.desktop} {
    max-width: ${sizes.xl};
  }
`;
